import { useInfiniteQuery } from '@tanstack/react-query'
import {
  getMembersPaginated,
  MEMBERS_PAGE_SIZE,
} from '@/services/membersService'
import { useAuth } from '@/hooks/useAuth'
import type { MembersPage } from '@/services/membersService'
import { INFINITE_MEMBERS_KEY } from '@/constants/queryKeys'
import type { QueryDocumentSnapshot, DocumentData } from 'firebase/firestore'

export function useInfiniteMembers() {
  const { churchId } = useAuth()

  // TODO: remove - debug
  console.log(
    '[useInfiniteMembers] churchId:',
    churchId,
    'enabled:',
    !!churchId,
  )

  return useInfiniteQuery<
    MembersPage,
    Error,
    {
      pages: MembersPage[]
      pageParams: (QueryDocumentSnapshot<DocumentData> | null)[]
    },
    string[],
    QueryDocumentSnapshot<DocumentData> | null
  >({
    queryKey: [INFINITE_MEMBERS_KEY, churchId!],
    queryFn: ({ pageParam }) => getMembersPaginated(churchId!, pageParam),
    initialPageParam: null,
    getNextPageParam: (lastPage) =>
      lastPage.members.length < MEMBERS_PAGE_SIZE
        ? undefined
        : lastPage.lastDoc,
    enabled: !!churchId,
  })
}
